import SvgDestinations from "@assets/topN/svg/destinations.svg"
import SvgFood from "@assets/topN/svg/food.svg"
import SvgHotel from "@assets/topN/svg/hotel.svg"

/** Api 狀態 */
export enum ApiStatus {
  Success = '001',
  Fail = '002',
  ValidateTokenFail = '003',
  UpdateTimeConflict = '004',
  ValidateSearch = '005',
}

/** 申請類型 */
export enum AssetEventCode {

  /** 公開權限申請 */
  takeon = 'takeon',

  /** 私有權限申請 */
  takeoff = 'takeoff',

  /** 素材檢舉 */
  mediareport = 'mediareport',

  /** POI 建議 */
  poisuggest = 'poisuggest',

  /** KOC 活動 */
  kocactivity = 'kocactivity',

  /** 意見回饋 */
  feedback = 'feedback',
}

/** 素材類型 */
export enum MediaType {

  /** 照片 */
  photo = 'photo',

  /** 影片 */
  film = 'film',
}

export enum QuestionType {
  Radio = 'Radio',
  Text = 'Text',
  TextArea = 'TextArea',
  SingleSelect = 'SingleSelect',
  MultipleSelect = 'MultipleSelect',
  UploadFile = 'UploadFile'
}

export enum Device {
  iOS = 'ios',
  Android = 'android',
  Web = 'web'
}

export enum LocationType {
  LcoationCountry = 'LcoationCountry',
  LocationCity = 'LocationCity',
  LocationArea = 'LocationArea'
}

export class Category {
  /** 景點 */
  static  EnterTainment = {
    Id: "9B471F78-4C89-42BA-BF96-5C96388B6898",
    Key: "enterTainment",
    Name: "景點",
    Svg: SvgDestinations,
  }

  /** 美食 */
  static Food = {
    Id: "9449DAA2-12AE-4A65-AA31-8EF93283763F",
    Key: "food",
    Name: "美食",
    Svg: SvgFood,
  }

  /** 住宿 */
  static Moon = {
    Id: "979A54EC-F96D-411B-A9AD-4BDE4C64697B",
    Key: "moon",
    Name: "住宿",
    Svg: SvgHotel,
  }
}

export enum CouponType {
  Link = 'Link',
  CouponImage = 'CouponImage',
  TextAndCouponImage = 'TextAndCouponImage'
}

export class WeekNameMap {
  static JpMap: { [key: string]: string } = {
    'monday': '月曜日',
    'tuesday': '火曜日',
    'wednesday': '水曜日',
    'thursday': '木曜日',
    'friday': '金曜日',
    'saturday': '土曜日',
    'sunday': '日曜日',
  }
}

/** 語系 */
export enum Language {
  ZhTw = 'zh-tw',
  JaJp = 'ja-jp',
  EnUs = 'en-us',
}